var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-10.6 0 133.477 133.477",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.357 116.784c-2.448 4.032-4.896 7.056-7.848 9.863-3.312 2.952-4.248 5.544-11.88 6.553-5.4 1.008-10.08-1.009-11.88-1.8-5.4-2.521-8.209-3.312-11.448-3.312-3.168 0-5.832.792-11.16 3.24-1.656.863-6.12 2.808-11.592 1.8-5.616-1.008-8.496-3.168-10.584-4.968-4.32-3.816-7.56-7.416-10.512-11.592l86.904.216z",
    fill: "#1e71b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.286 49.608c2.52-5.688 5.832-9.504 9.144-12.168 8.424-6.912 22.176-7.344 28.512-5.688 5.184 1.296 8.856 4.464 14.688 4.464 6.12 0 9.647-3.096 14.472-4.464 6.336-1.584 20.16-1.08 29.16 5.832 2.664 2.016 5.111 4.752 6.479 6.264-3.239 2.376-5.184 4.104-6.768 5.76H4.286z",
    fill: "#6fb353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.974 49.608c-1.512 1.656-2.592 3.24-3.816 5.472-1.439 2.592-3.168 6.12-3.6 11.448H.038c.072-.864.144-1.8.288-2.736.864-5.688 2.232-10.368 3.96-14.184h95.688z",
    fill: "#fff22d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.558 66.528a55.508 55.508 0 0 0 0 4.896c.216 3.96 1.584 8.352 3.384 11.88l-94.104-.216C.542 77.4-.178 71.568.038 66.528h92.52z",
    fill: "#e0922f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.941 83.304a24.623 24.623 0 0 0 2.664 4.32c6.192 7.92 8.856 7.92 13.68 10.368-.359.863-.647 1.656-1.008 2.376L7.31 100.152C5.294 95.76 3.206 89.568 1.838 83.088l94.103.216z",
    fill: "#cc2229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.277 100.368c-3.023 7.056-5.472 12.239-7.92 16.416l-86.903-.216c-2.88-4.248-5.472-8.929-8.424-14.761-.216-.504-.504-1.08-.72-1.655l103.967.216z",
    fill: "#5a308d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.109 10.224c-.504 3.6-2.304 8.208-5.184 11.16-3.097 3.312-7.92 6.912-10.801 8.712-1.584 1.008-5.688 1.152-9.071 1.512-.432-3.024-.504-5.616.432-8.424 1.224-3.312 2.809-8.064 5.328-11.376 3.096-4.104 6.624-6.912 8.568-7.92C72.974 2.592 77.294.648 81.037 0c.145 3.312.649 7.056.072 10.224z",
    fill: "#6fb353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.23ceb1b80fa0a57ecb1ed91f4e252a79.svg";
export { ForwardRef as ReactComponent };